'use strict';

var enabled = true;

if(process.env.NODE_ENV === 'development') {
    enabled = false;
}

module.exports = {
    redisCache: {
        enabled: enabled
    },
    piwikEnabled: false,
    pollsEnabled: false,
    postInfiniteScroll: true,
    storyBand: true,
    mobilePhotoGallery: true,
    welcomeAdV2: true,
    jwPlayer: false
};
